/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Inject, OnDestroy, Pipe, PipeTransform} from '@angular/core';

import {formatLocaleDate} from '../locale/locale-date-format';
import {AppLocaleService} from '../locale/app-locale.service';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {BufferedValue, bufferTemplateValue, createBufferedValue} from '../util/template-state';

@Pipe({
  standalone: false,
  name: 'localeDate',
  pure: false
})
export class LocaleDatePipe implements PipeTransform, OnDestroy {
  /**
   * Impure so timezone/locale prefs can refresh without the date input
   * changing. Profile locale can still settle mid-CD (navigator "28 aug."
   * → en-GB "28 Aug") which NG0100s QueryRoutePage and every other
   * localeDate cell. Keep the checked string stale until the next macrotask.
   */
  private readonly formatted: BufferedValue<string | null> = createBufferedValue(null);
  private destroyed = false;

  constructor(
    private readonly appLocale: AppLocaleService,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  transform(value: Date | string | number | null | undefined, format = 'medium'): string | null {
    const next = (value === null || value === undefined || value === '')
      ? null
      : formatLocaleDate(
        value,
        format,
        this.appLocale.getLocaleId(),
        this.LocalNetworkProfile.get('timeZone') || 'utc'
      );
    return bufferTemplateValue(this.formatted, next, {
      isAlive: () => !this.destroyed,
      onCommit: () => this.cdr.markForCheck()
    });
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }
}
